import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormArray, FormControl, FormGroup} from '@angular/forms';
import {ShipmentInstructionService} from '../../@shared/new-services/shipment-instruction.service';
import {MessageService} from 'primeng/api';
import {FileUpload} from 'primeng/fileupload';
import {Observable} from 'rxjs';

@Component({
    selector: 'cargo-details',
    templateUrl: './cargo-details.component.html',
    styleUrls: ['./cargo-details.component.scss']
})
export class CargoDetailsComponent implements OnInit {

    @Input() siAction = 'add';

    @Input() siContainers: any[] = [];
    @Input() isPreviewSI = false;
    cargoDetailsForm: any = new FormArray([]);
    @Output() emitCargoDetails: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitSiDocuments: EventEmitter<any> = new EventEmitter<any>();

    containerTypesArray = [
        {containerId: 'General', containerDescription: 'General'},
        {containerId: 'Hazardous', containerDescription: 'Hazardous'},
        {containerId: 'Perishable', containerDescription: 'Perishable'},
        {
            containerId: 'ODC',
            containerDescription: 'Heavy / ODC - (Over Dimension Cargo)'
        },
        {containerId: 'Automobile', containerDescription: 'Automobile'},
        {containerId: 'Live Animal', containerDescription: 'Live Animal'},
    ];

    filteredCommodities: any;
    commodities: any;
    weightUnit: any[] = ['KG', 'LBS'];
    measureUnit: any[] = ['CMS', 'INC'];
    kindOfPackages: any;

    constructor(private shipmentInstructionService: ShipmentInstructionService,
                private messageService: MessageService) {
    }

    ngOnInit(): void {
        this.getKindOfPackages();
        this.siContainers?.map((siContainer) => {
            this.addSiContainerDetail(siContainer);
        });
    }


    getCommodities(prefix: string) {
        this.shipmentInstructionService
            .getCommodities(prefix)
            .subscribe((commodities) => {
                this.commodities = commodities;
            });
    }

    completeCommodities(event: any) {
        const filtered: any[] = [];
        const query = event.query;

        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < this.commodities?.length; i++) {
            const commodity = this.commodities[i];
            if (commodity.commodityDescription.toLowerCase().indexOf(query.toLowerCase()) === 0) {
                filtered.push(commodity);
            }
        }

        this.filteredCommodities = filtered;
    }

    getCommoditiesByPrefix(event: any) {
        const prefix = event?.target.value;

        if (prefix?.length >= 3) {
            this.getCommodities(prefix);
            return;
        }
    }

    getKindOfPackages() {
        this.shipmentInstructionService
            .getKindOfPackages()
            .subscribe((kindOfPackages) => {
                this.kindOfPackages = kindOfPackages;
            });
    }

    presentToastMessage(severity, detail) {
        this.messageService
            .add(
                {
                    severity,
                    summary: 'Cargo Details Message !',
                    key: 'cargo-details-message',
                    detail,
                }
            );
    }

    emitCargoDetailsValue() {
        const siContainers = this.cargoDetailsForm.value;

        siContainers?.map((x) => {
            x.containerDocuments = [];
        });
        this.emitCargoDetails
            .emit(siContainers);
    }


    emitSiDocumentsForUpload(documentTypeId: any, event: any, cargoDetails: any, fileUploadComponent: FileUpload) {
        const files = event?.files;
        this.emitSiDocuments.emit(
            {
                files,
                documentTypeId,
                cargoDetails,
                fileUploadComponent
            }
        );
    }

    getDocumentByDocumentTypeId(siContainerDocuments: any, documentTypeId: string): any {
        const containerDocument: Observable<any> = siContainerDocuments?.map((document) => {
            if (document?.documentTypeId === documentTypeId) {
                document.name = document?.name ? document?.name : 'File Name is Empty';
                return document as Observable<any>;
            }
        });
        return containerDocument[0];
    }

    addSiContainerDetail(siContainer?: any) {
        const siContainerDetail: FormGroup = new FormGroup({

            // Common fields for All Shipment Types
            bookingId: new FormControl(siContainer?.bookingId ? siContainer?.bookingId : null),
            shipUnitId: new FormControl(siContainer?.shipUnitId ? siContainer?.shipUnitId : this.isPreviewSI),
            cargoType: new FormControl(
                siContainer?.cargoType ? siContainer?.cargoType : 'General'),
            length: new FormControl({
                value: siContainer?.length ? siContainer?.length : '', disabled: this.isPreviewSI
            }),
            lengthUOM: new FormControl({
                value: siContainer?.lengthUOM ? siContainer?.lengthUOM : 'CMS', disabled: this.isPreviewSI
            }),
            width: new FormControl({
                value: siContainer?.width ? siContainer?.width : '', disabled: this.isPreviewSI
            }),
            widthUOM: new FormControl({value: siContainer?.widthUOM ? siContainer?.widthUOM : 'CMS', disabled: this.isPreviewSI}),
            height: new FormControl({value: siContainer?.height ? siContainer?.height : '', disabled: this.isPreviewSI}),
            heightUOM: new FormControl({value: siContainer?.heightUOM ? siContainer?.heightUOM : 'CMS', disabled: this.isPreviewSI}),
            // TODO: To check with BackEnd Service weather this requires or not CommodityObj.
            commodityObj: new FormControl(siContainer?.commodityObj ?
                siContainer?.commodityObj : null),
            commodity: new FormControl({
                value: siContainer?.commodity ? siContainer?.commodity : null, disabled: this.isPreviewSI
            }),
            kindOfPackage: new FormControl({
                value: siContainer?.kindOfPackage ? siContainer?.kindOfPackage : null,
                disabled: this.isPreviewSI
            }),
            numberOfPackage: new FormControl({
                value: siContainer?.numberOfPackage ? siContainer?.numberOfPackage : null,
                disabled: this.isPreviewSI
            }),
            volume: new FormControl({value: siContainer?.volume ? siContainer?.volume : null, disabled: this.isPreviewSI}),
            volumeUOM: new FormControl({value: 'CBM', disabled: this.isPreviewSI}),
            grossWeight: new FormControl({value: siContainer?.grossWeight ? siContainer?.grossWeight : null, disabled: this.isPreviewSI}),
            grossWeightUOM: new FormControl({
                value: siContainer?.grossWeightUOM ? siContainer?.grossWeightUOM : 'KG', disabled: this.isPreviewSI
            }),
            imcoClass: new FormControl({value: siContainer?.imcoClass ? siContainer?.imcoClass : null, disabled: this.isPreviewSI}),
            unNumber: new FormControl({value: siContainer?.unNumber ? siContainer?.unNumber : null, disabled: this.isPreviewSI}),
            temperature: new FormControl({
                value: siContainer?.temperature ? siContainer?.temperature : null, disabled: this.isPreviewSI
            }),
            temperatureUOM: new FormControl('C'),

            // Documents Related Payload
            containerDocuments: new FormControl(siContainer?.containerDocuments ? siContainer?.containerDocuments : []),

            // Field of FCL/LCL Shipment Type
            containerSubTypeDescription: new FormControl(null),
            containerNumber: new FormControl(null),
            sealNumber: new FormControl(null),
            netWeight: new FormControl(null),
            netWeightUOM: new FormControl(null),
            vgmWeight: new FormControl(null),
            vgmWeightUOM: new FormControl(null),
            humidity: new FormControl(null),
            ventilation: new FormControl(null),
            ventilationUOM: new FormControl(null),
            weightInTonnes: new FormControl(null),

            // Field of AIR Shipment Type
            cageLength: new FormControl({
                value: siContainer?.cageLength ? siContainer?.cageLength : '',
                disabled: this.isPreviewSI
            }),
            cageLengthUOM: new FormControl({
                value: siContainer?.cageLengthUOM ? siContainer?.cageLengthUOM : 'CMS', disabled: this.isPreviewSI
            }),
            cageWidth: new FormControl({
                value: siContainer?.cageWidth ? siContainer?.cageWidth : '', disabled: this.isPreviewSI
            }),
            cageWidthUOM: new FormControl({
                value: siContainer?.cageWidthUOM
                    ? siContainer?.cageWidthUOM : 'CMS', disabled: this.isPreviewSI
            }),
            cageHeight: new FormControl({
                value: siContainer?.cageHeight ? siContainer?.cageHeight : '', disabled: this.isPreviewSI
            }),
            cageHeightUOM: new FormControl({
                value: siContainer?.cageHeightUOM ? siContainer?.cageHeightUOM : 'CMS',
                disabled: this.isPreviewSI
            }),
            chargeableWeight: new FormControl({
                value: siContainer?.chargeableWeight ? siContainer?.chargeableWeight : '', disabled: this.isPreviewSI
            }),
            chargeableWeightUOM: new FormControl({
                value: siContainer?.chargeableWeightUOM ?
                    siContainer?.chargeableWeightUOM : 'KG', disabled: this.isPreviewSI
            }),
            wheelBaseDimension: new FormControl({
                value: siContainer?.wheelBaseDimension ? siContainer?.wheelBaseDimension : '',
                disabled: this.isPreviewSI
            }),
            typeOfUnPacking: new FormControl({
                value: siContainer?.typeOfUnPacking ? siContainer?.typeOfUnPacking : '',
                disabled: this.isPreviewSI
            }),
            // Container Documents
            vgmDocument: new FormControl(siContainer?.vgmDocument ? siContainer?.vgmDocument : null),
            liveAnimalDocument: new FormControl(siContainer?.liveAnimalDocument ? siContainer?.liveAnimalDocument : null),
            msdsDocument: new FormControl(siContainer?.msdsDocument ? siContainer?.msdsDocument : null),
            ataCarnetDocument: new FormControl(siContainer?.ataCarnetDocument ? siContainer?.ataCarnetDocument : null),
        });
        // @ts-ignore
        this.cargoDetailsForm.push(siContainerDetail);
    }

    getFormGroup(i: number): FormGroup {
        const cargoDetailForm: FormGroup = this.cargoDetailsForm.at[i] as FormGroup;
        return cargoDetailForm;
    }

}
